import React from 'react';
import JournalSection from '../components/JournalSection';
import Footer from '../components/Footer';
import './Journal.css';

const Journal = () => {
  return (
    <div className="journal-page">
      <JournalSection />
      <Footer />
    </div>
  );
};

export default Journal;

